import React from 'react'
import { cn } from './cn'

export type IconButtonVariant = 'bare' | 'ghost' | 'bar'

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * `ghost` is the compact Tier 3 inline action; `bare` is for shell-specific
   * controls; `bar` is the 36px ink icon button that sits in an App-surface
   * column header or pane bar (search, settings,「…」).
   */
  variant?: IconButtonVariant
}

/**
 * 純圖示控制項的共用語意殼。版面可用 className 補上位置（如 topnav 的
 * hamburger），互動、游標與鍵盤焦點則維持由這個元件和 `.icon-button` 統一。
 */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { className, type, variant = 'bare', ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cn(
        'icon-button cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2',
        variant === 'ghost' &&
          'inline-flex size-6 shrink-0 items-center justify-center rounded-[var(--radius)] border-0 bg-transparent text-[var(--muted)] transition-colors hover:bg-[var(--fg-soft)] hover:text-[var(--fg)] focus-visible:outline-[var(--focus-ring)] disabled:cursor-not-allowed disabled:opacity-40',
        variant === 'bar' &&
          'inline-grid size-9 shrink-0 place-items-center rounded-[var(--radius)] border-0 bg-transparent text-foreground transition-colors hover:bg-[var(--fg-soft)] aria-expanded:bg-[var(--fg-soft)] focus-visible:outline-[var(--focus-ring)] disabled:cursor-not-allowed disabled:opacity-40 [&_svg]:size-4.5',
        className
      )}
      {...rest}
    />
  )
})
